function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var Scale = /*#__PURE__*/function () {
  function Scale(_ref) {
    var min = _ref.min,
      max = _ref.max,
      rangeMin = _ref.rangeMin,
      rangeMax = _ref.rangeMax,
      outOfRange = _ref.outOfRange;
    _classCallCheck(this, Scale);
    this.min = min;
    this.max = max;
    this.rangeMin = rangeMin;
    this.rangeMax = rangeMax;
    this.outOfRange = outOfRange;
  }
  return _createClass(Scale, [{
    key: "getValue",
    value: function getValue(domainVal) {
      if (domainVal < this.min || domainVal > this.max) {
        return this.outOfRange;
      }
      return this.rangeMax / domainVal;
    }
  }]);
}();
;